<template>
  <v-flex
    xs12
    sm6
    lg4
    @click="openProject"
  >
    <v-card
      ripple
      :to="link"
    >
      <v-card-title>
        <v-container
          class="pa-0"
          fluid
        >
          <v-row>
            <v-col
              class="body-2 text-truncate"
              sm="9"
              xl="10"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <slot />
                  </div>
                </template>
                <span>
                  <v-icon class="mr-2">mdi-file-document-outline</v-icon>
                  {{ projectData.projectName }}
                </span>
              </v-tooltip>
            </v-col>
            <v-col
              class="pt-1"
              sm="3"
              xl="2"
            >
              <v-icon>mdi-file-document-edit-outline</v-icon>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-card-text class="d-flex align-content-center flex-wrap mt-n2">
        <v-img
          v-if="src != ''"
          class="d-flex align-content-center flex-wrap mt-1 mb-n3"
          contain
          aspect-ratio="1.6"
          :lazy-src="src"
          :src="src"
        />
        <v-img
          v-else
          class="d-flex align-content-center flex-wrap mt-1 mb-n3"
          contain
          aspect-ratio="1.6"
        >
          {{ defaultTmb }}
        </v-img>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    thumb: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    projectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultTmb: "mdi-archive-settings",
    };
  },
  computed: {
    src() {
      if (this.projectData.projId) {
        return "./mediacenter/tmb/" + this.projectData.projId + ".png?t=" + Date.now().toString();
      } else {
        return "";
      }
    },
  },
  methods: {
    openProject() {
      this.$emit("openProject", this.projectData);
    },
  },
};
</script>

<style></style>
